import styled from 'styled-components'

export const Wrapper = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  z-index: 2;
  border-radius: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding-left: 12px;
  padding-right: 12px;
  width: calc(100% );
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  border-radius: 8px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .pagination_footer_slice {
    width: 1px;
    height: 24px;
    margin-left: 20px;
    margin-right: 20px;
  }
  .pagination_footer_row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .pagination_footer_text {
    font-family: Inter;
    font-size: 11px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;

    letter-spacing: 0px;
    color: #212121;
  }
  .pagination_footer_strong {
    font-family: Inter;
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
  }
`

export const PaginationButtons = styled.div`
  width: 72px;
  height: 24px;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  background: #ffffff 0% 0% no-repeat padding-box;
  margin-left: 8px;
  .pagination_footer_button {
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 4px 0px 0px 4px;
    height: 100%;
    flex: 1;
    padding-top: 2px;
  }
  .pagination_footer_button + .pagination_footer_button {
    border-radius: 0px 4px 4px 0px;
    border-left: #e0e0e0;
  }

  .pagination_footer_off {
    background: #e0e0e0;
    :hover {
      background: #e0e0e0;
    }
  }
`

export const PaginBlock = styled.div`
  margin-left: 12px;
  margin-right: 12px;

  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #757575;
  border-radius: 12px;
  height: 24px;
  width: 48px;
  // min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font: normal normal 600 14px/21px;
  letter-spacing: 0px;
  color: #212121;

  .paginBlock_input {
    outline: none;
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
    text-align: center;
  }
`
